var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast-item"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,attrs:{"id":"item-container"}},[_c('div',{class:item,style:(_vm.items.length===(index+1)?'':_vm.style)})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }